import { render, staticRenderFns } from "./DeleteAdmin.vue?vue&type=template&id=49f46afc"
import script from "./DeleteAdmin.vue?vue&type=script&lang=js"
export * from "./DeleteAdmin.vue?vue&type=script&lang=js"
import style0 from "./DeleteAdmin.vue?vue&type=style&index=0&id=49f46afc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports